import React from 'react';

import { atom } from 'recoil';
import dayjs, { Dayjs } from 'dayjs';

/* 区画ダイアログ */
type SectionList = {
  sectionId: string;
  sectionName: string;
};
type Section = {
  title: string;
  sectionList: SectionList[];
};

type SectionDialogInput = {
  open: boolean;
  sectionData: Section;
  defSection: string;
  defStartTime: Dayjs;
  defEndTime: Dayjs;
  availableStartTime: Dayjs;
  availableEndTime: Dayjs;
  date: string,
  onLoginClick?: (startTime: string, endTime: string, sectionsList: string[]) => void;
  onGuestClick?: (startTime: string, endTime: string, sectionsList: string[]) => void;
};

const SectionDialogState = atom<SectionDialogInput>({
  key: 'dialogState/sectionDialogState',
  default: {
    open: false,
    sectionData: {
      title: '',
      sectionList: [],
    },
    defSection: '',
    defStartTime: dayjs().hour(0).minute(0),
    defEndTime: dayjs().hour(0).minute(0),
    availableStartTime: dayjs().hour(0).minute(0),
    availableEndTime: dayjs().hour(0).minute(0),
    date: '',
    onLoginClick: () => undefined,
    onGuestClick: () => undefined
  }
});

/* エリア情報ダイアログ */
type AreaInfo = {
  facilityId: string;
  areaId: string;
};
type AreaInfoDialogInput = {
  open: boolean;
  areaInfoData: AreaInfo;
  onDetailClick?: any;
  onConfirmClick?: any;
};

const AreaInfoDialogState = atom<AreaInfoDialogInput>({
  key: 'dialogState/areaInfoDialogState',
  default: {
    open: false,
    areaInfoData: {
      facilityId: '',
      areaId: ''
    },
    onConfirmClick: () => undefined
  }
});

/* メッセージダイアログ */
type Message = {
  title: string;
  message: string;
};

type MessageDialogInput = {
  open: boolean;
  messageData: Message;
  onOkClick?: () => undefined;
  onCancelClick?: () => undefined;
};

const MessageDialogState = atom<MessageDialogInput>({
  key: 'dialogState/messageDialogState',
  default: {
    open: false,
    messageData: {
      title: '',
      message: ''
    },
    onOkClick: undefined,
    onCancelClick: undefined
  }
});

/* 備品情報ダイアログ */
type EquipmentInfo = {
  equipmentId: string;
  facilityId: string;
  num: number;
  priceIndex: number;
};
type EquipmentInfoDialogInput = {
  open: boolean;
  equipmentInfoData: EquipmentInfo;
  onAddCartClick?: any;
};

const EquipmentInfoDialogState = atom<EquipmentInfoDialogInput>({
  key: 'dialogState/equipmentInfoDialogState',
  default: {
    open: false,
    equipmentInfoData: {
      equipmentId: '',
      facilityId:'',
      num: 0,
      priceIndex: 0
    },
    onAddCartClick: () => undefined
  }
});

export { SectionDialogState, AreaInfoDialogState, MessageDialogState, EquipmentInfoDialogState };

export type { SectionDialogInput, AreaInfoDialogInput, MessageDialogInput, EquipmentInfoDialogInput };
